/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { ViewValues } from '@g17eco/types/surveyOverview';

interface BreadcrumbsParams {
  cardCategory?: string;
  cardGroup?: string;
  cardSubCategory?: string;
  cardSubGroup?: string;
  leafGroup?: string;
  leafCategory?: string;
  leafChildGroup?: string;
  leafChildCategory?: string;
}

export interface BreadcrumbsRouteParams extends BreadcrumbsParams {
  surveyId: string;
  initiativeId: string;
  page: string;
  view: ViewValues | string;
  baseRoute?: string;
}

export const breadcrumbParams: (keyof BreadcrumbsParams)[] = [
  'cardCategory',
  'cardGroup',
  'cardSubCategory',
  'cardSubGroup',
  'leafCategory',
  'leafGroup',
  'leafChildCategory',
  'leafChildGroup',
];

const breadcrumb = ['view', ...breadcrumbParams].map(s => `${s}?`).join('/:');
export const sidebarPath = `:${breadcrumb}`;
